import { Dispatch } from 'react';
import { AnyAction } from 'redux';

import routes from '../routes';
import { authActions } from '../store/modules/auth';

import isSameRoute from './router/isSameRoute';

const { Router } = routes;

type TransitionOptions = {
  shallow?: boolean;
  locale?: string | false;
  scroll?: boolean;
};

const sessionGuard = (dispatch: Dispatch<AnyAction>) => {
  dispatch(authActions.startSessionWatcher());

  const removeListeners = () => Router.events.off('routeChangeStart', handleRouteChange);

  const handleRouteChange = (nextPath: string, { shallow }: TransitionOptions) => {
    if (shallow || isSameRoute(nextPath)) return;

    dispatch(authActions.stopSessionWatcher());
    removeListeners();
  };

  Router.events.on('routeChangeStart', handleRouteChange);
};

export default sessionGuard;
